export class ActionsListDispatcher {
    static $inject = ['props'];
    constructor(props) {
        Object.assign(this, props);
    }
}
export class ActionsListUpdateAndSave extends ActionsListDispatcher {
    constructor() {
        super();
    }
}
export class ActionsListDeleteItem extends ActionsListDispatcher {
    static $inject = ['props'];
    constructor(props) {
        super(props);
        Object.assign(this, props);
    }
}
export class ActionsListOpenDetail extends ActionsListDispatcher {
    static $inject = ['props'];
    constructor(props) {
        super(props);
        Object.assign(this, props);
    }
}
export class ActionsListSelectAction extends ActionsListDispatcher {
    static $inject = ['props'];
    constructor(props) {
        super(props);
        Object.assign(this, props);
    }
}
export class ActionsListAddAction extends ActionsListDispatcher {
    static $inject = ['props'];
    constructor(props) {
        super(props);
        Object.assign(this, props);
    }
}
